import {
  Divider as MuiDivider,
  ListItemButton as MuiListItemButton,
  Paper,
  styled,
  Typography,
} from '@mui/material';

export const DataCatalogHandlerWrapper = styled(Paper)(({ theme }) => ({
  width: 360,
  height: '100%',
  borderTop: `1px solid ${theme.palette.border.main}`,
  borderRight: `1px solid ${theme.palette.border.main}`,
}));

export const Divider = styled(MuiDivider)(({ theme }) => ({
  borderColor: theme.palette.border.main,
}));

export const ListItemButton = styled(MuiListItemButton)(({ theme }) => ({
  display: 'block',
  padding: '8px 12px',
  marginBottom: '2px',
  backgroundColor: theme.palette.primary.light,
  border: `1px solid ${theme.palette.border.main}`,
  '&.Mui-selected': {
    color: theme.palette.text.primary,
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '-2px',
  },
}));

export const SectionTitle = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 700,
  mb: 4,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
});
